export const SENTRY_TRIAGE_PROMPT = `You are a senior software engineer triaging a Sentry error alert.

## Error Details

**Title:** {{trigger.issueTitle}}
**Sentry URL:** {{trigger.issueUrl}}
**Project:** {{trigger.sentryProjectSlug}}

{{#if trigger.stacktrace}}
## Stacktrace

{{trigger.stacktrace}}
{{/if}}

## Your TaskGH

Produce a concise triage summary in this format:

1. **What happened**: One-sentence description of the error
2. **Likely root cause**: Best guess based on the stacktrace and error message
3. **Severity estimate**: Critical / High / Medium / Low — with brief justification
4. **Affected area**: Which part of the codebase / service is impacted
5. **Recommendation**: Should this be investigated immediately, or can it wait?

Keep the summary short and actionable — this will be shown to an engineer deciding whether to investigate or ignore this issue.`;
